module.exports = __webpack_public_path__ + "img/google-plus-g.0768d91a.svg";